import CareerPlanningView from './CareerPlanningView'
export default CareerPlanningView
